var swiper = new Swiper(".clImageLinkSlider", {
  slidesPerView: 2,
  spaceBetween: 16,
  slidesPerGroup: 2,
  speed: 500,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    480: {
      slidesPerView: 3,
      slidesPerGroup: 2,
      spaceBetween: 24,
    },
    991: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 24,
    },
  },
});